import { Box, BoxProps } from '@chakra-ui/react'

import './DotLoader.css'

type DotLoaderProps = BoxProps & {
  loaderHeight?: string | number
  loaderWidth?: string | number
}

export const DotLoader = ({
  loaderWidth,
  loaderHeight,
  ...styleProps
}: DotLoaderProps) => {
  return (
    <Box
      minWidth={loaderWidth}
      minHeight={loaderHeight}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      {...styleProps}
    >
      <div className="dot-pulse"></div>
    </Box>
  )
}
